// extracted by mini-css-extract-plugin
export default {"terms":"OnboardingTerms_terms__Q7ZmC","overflow":"OnboardingTerms_overflow__MxYnI","active":"OnboardingTerms_active__0m2Wl","shown":"OnboardingTerms_shown__AhAWn"};